/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetAllAssetPricesOptions,
  GetAllAssetPricesResponses,
} from '../types/GetAllAssetPrices'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get the current price of all assets
 * {@link /v1/price}
 */
export function getAllAssetPrices<ThrowOnError extends boolean = true>(
  options: Options<GetAllAssetPricesOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetAllAssetPricesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/price',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetAllAssetPricesResponses, ThrowOnError>>,
  )
}
